<template>
  <!-- SPAM HEADER -->
  <div v-if="isSpam" class="spam-header">
    <i class="ddi ddi-spam" />
    <span v-if="spamType === SpamTypes.POTENTIAL_SPAM">
      Warning! This conversation was detected as potential spam.
    </span>
    <span v-else-if="spamType === SpamTypes.SPAM">
      This conversation was marked as spam.
    </span>
    <dd-button
      v-if="allowToggle"
      :is-loading="isTogglingSpam"
      size="small"
      type="flat"
      @click="$emit('toggle-spam')"
    >Remove from spam?</dd-button>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Helpers */
import TypeAssistant from '@/helpers/type-assistant'

/* Types */
import { SpamTypes } from '@/types'

export default defineComponent({
  name: 'SpamHeader',

  props: {
    spamType: {
      type: Number,
      default: SpamTypes.NOT_SPAM,
    },
    isTogglingSpam: {
      type: Boolean,
      default: false,
    },
    allowToggle: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['toggle-spam'],

  data() {
    return {
      SpamTypes,
    }
  },

  computed: {
    isSpam(): boolean {
      return TypeAssistant.isSpam(this.spamType)
    },
  },
})
</script>

<style lang="scss">
.spam-header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-text-third);
  @include lettering--p;
  color: $color--white;
  padding: 8px 14px;
  margin-bottom: 20px;
  @include flex-row-horizontal-spacing(10px);
}
</style>
